export const hasTopOverflow = (element: HTMLElement) => element.scrollTop > 1;
export const hasBottomOverflow = (element: HTMLElement) =>
  element.scrollHeight > element.clientHeight + element.scrollTop + 1;
export const hasLeftOverflow = (element: HTMLElement) => element.scrollLeft > 0;
export const hasRightOverflow = (element: HTMLElement) =>
  element.scrollWidth > element.clientWidth + element.scrollLeft;

export const hasOverflow = (element: HTMLElement) =>
  hasTopOverflow(element) ||
  hasBottomOverflow(element) ||
  hasLeftOverflow(element) ||
  hasRightOverflow(element);
